<template>
  <v-list-item
    :key="alert.id"
    class="my-alerts-row"
    :class="{ selected: mapIt }"
    @click="rowSelect()"
  >
    <v-list-item-content>
      <v-list-item-title
        v-html="alert.name"
        class="application-heading"
      ></v-list-item-title>
      <v-list-item-subtitle>
        <span v-if="isExpired(alert.expiration.date)" style="color: red;">
          Expired
        </span>
        <span v-else>Expires {{ alert.expiration.date | DateFilter }}</span>
        <span v-if="!belongsToUser">
          &nbsp;&nbsp;Owner: {{ alert.owner.email }}
        </span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="canEdit" class="alert-action">
      <v-btn class="alert-action-btn" depressed small @click.stop="editAlert()">
        Edit
      </v-btn>
    </v-list-item-action>
    <v-list-item-action class="alert-action">
      <v-btn
        class="alert-action-btn"
        depressed
        small
        @click.stop="cloneAlert()"
      >
        Clone
      </v-btn>
    </v-list-item-action>
    <v-list-item-action class="alert-action">
      <v-btn
        class="alert-action-btn"
        depressed
        small
        @click.stop="deleteAlertBtnClick()"
      >
        <span v-if="!isDeleting">Delete</span>
        <v-progress-circular
          indeterminate
          v-if="isDeleting"
          size="16"
          width="2"
        ></v-progress-circular>
      </v-btn>
    </v-list-item-action>
    <ConfirmationPopup
      :show="deleteConfirmationShow"
      title="Deleting Alert"
      :text="'Are you sure you want to delete alert ' + alert.name"
      :buttonCancel="deleteConfirmationBtnCancel"
      :buttonAction="deleteConfirmationBtnAction"
    ></ConfirmationPopup>
  </v-list-item>
</template>

<script>
/**
 * @Overview A single entry in the alert list. This might be replaced by a common component
 * @NOTE: Possibly replaced by a common component.
 */

import dayjs from "dayjs";

import { mapGetters } from "vuex";
import DateFilter from "@/components/common/filters/DateFilter";
import { MODULE_PREFIX_ALERTS, MODULE_PREFIX_USER } from "@/store";

import {
  DELETE_USER_ALERT,
  OPEN_ALERT_WIZARD,
  DELETE_SHARED_ALERT,
} from "@/store/actions.type";

import { MAIN_MAP_ID } from "@/common/constants/maps";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "AlertListItem",
  components: {
    ConfirmationPopup: () => import("@/components/common/ConfirmationPopup"),
  },
  props: {
    alert: {
      required: true,
      type: Object,
    },
    isMapped: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      deleteConfirmationShow: false,
      isDeleting: false,
      mapIt: this.isMapped,
    };
  },
  filters: {
    DateFilter,
  },
  computed: {
    ...mapGetters({
      profile: MODULE_PREFIX_USER + "profile",
    }),
    deleteConfirmationBtnCancel() {
      return {
        text: "Cancel",
        onClickFnc: this.deleteCancelClick,
      };
    },
    deleteConfirmationBtnAction() {
      return {
        text: "Confirm",
        onClickFnc: this.deleteConfirmClick,
      };
    },
    map() {
      return this.maps[MAIN_MAP_ID];
    },
    layerId() {
      if (this.alert && this.alert.id) {
        return `layer-${this.alert.id}`;
      }
      return `layer-${this._uid}`;
    },
    belongsToUser() {
      return this.alert.owner.id === this.profile.UserID;
    },
    canEdit() {
      return this.belongsToUser && !this.alert.hideEditControls;
    },
  },
  methods: {
    isExpired(timestamp) {
      const DATE = new Date(timestamp * 1000);
      return dayjs().isAfter(DATE);
    },
    rowSelect() {
      this.mapIt = !this.mapIt;
      this.$emit(EMITTED_ACTIONS.CHANGE, {
        mapped: this.mapIt,
        alert: {
          id: this.alert.id,
        },
        layerId: this.layerId,
      });
      if (this.mapIt) {
        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.alerted_content,
          EVENT_ACTIONS.enabled,
          "Explore Content - Map Alert"
        );
      }
    },
    async editAlert() {
      await this.$store.dispatch(MODULE_PREFIX_ALERTS + OPEN_ALERT_WIZARD, {
        alert: this.alert,
      });
    },
    async cloneAlert() {
      await this.$store.dispatch(MODULE_PREFIX_ALERTS + OPEN_ALERT_WIZARD, {
        alert: this.alert,
        clone: true,
      });
    },
    async deleteConfirmClick() {
      this.deleteConfirmationShow = false;
      this.isDeleting = true;
      if (this.belongsToUser) {
        return await this.$store.dispatch(
          MODULE_PREFIX_ALERTS + DELETE_USER_ALERT,
          this.alert
        );
      }
      return await this.$store.dispatch(
        MODULE_PREFIX_ALERTS + DELETE_SHARED_ALERT,
        this.alert
      );
    },
    deleteCancelClick() {
      this.deleteConfirmationShow = false;
    },
    deleteAlertBtnClick() {
      this.deleteConfirmationShow = true;
    },
  },
};
</script>

<style scoped>
.my-alerts-row {
  background: white;
  margin-bottom: 10px;
  border-radius: 9px;
}

.my-alerts-row {
  border-radius: 9px;
  height: 62px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
  -webkit-box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14) !important;
}

.my-alerts-row.selected {
  border: 2px blue solid !important;
}

.alert-action {
  padding: 0 5px 0 5px;
}
.alert-action-btn {
  color: #959595;
  border-radius: 9px;
}
.alert-action-unsub-btn {
  font-size: 10px;
}
</style>
